import React from "react";

export const GraphicFileCell = ({ row }) => {
  const completionScreenVisual = row.original.completionScreenVisual[0];

  return <a href={completionScreenVisual.dataUrl}>{completionScreenVisual.name} </a>;
};
